const participantComplete = row => {
  const identity =
    row.tipo_pessoa === 'PJ'
      ? row.nome_empresarial && row.cnpj
      : row.name && row.cpf;
  return Boolean(identity && row.creci && row.porcentagem_real);
};

export const commissionGroupComplete = (group, rows, enabled = true) => {
  if (group.toggleLabel && !enabled) return true;
  if (group.single) return Boolean(rows[0]?.porcentagem_real);
  if (!rows.length) return false;

  return rows.every(participantComplete);
};

export const commissionSheetComplete = (groups, form, enabledByGroup = {}) =>
  groups.every(group =>
    commissionGroupComplete(
      group,
      form[group.id] || [],
      enabledByGroup[group.id] ?? true
    )
  );
